import { FC } from "react";
import { useNavigate } from "react-router-dom";

import { useIsDesktop } from "@hooks/layout";

import { QuickFilterType, TQuickFilter } from "@store/actions/quickFilters";
import { useAppDispatch } from "@store/hooks";
import { resetTracks, setIsLoading } from "@store/reducers/catalogue";

import { ERoutes } from "@utils/constants";
import { makePath } from "@utils/makePath";

import { StyledQuickFilter } from "./components";

export const QuickFilter: FC<TQuickFilter & { type: QuickFilterType }> = ({ name, slug, background, ...rest }) => {
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();
  const dispacth = useAppDispatch();

  const handleNavigate = () => {
    dispacth(setIsLoading(true));
    dispacth(resetTracks());
    navigate(makePath(ERoutes.SelectedQuickFilter, slug));
  };

  return (
    <StyledQuickFilter {...rest} isDesktop={isDesktop} bg={background} onClick={() => handleNavigate()}>
      {name}
    </StyledQuickFilter>
  );
};
